import React from 'react';
import Lightbox from './Lightbox';
import useLightbox from '../hooks/useLightbox';

const IMAGES = [
  {
    src: 'https://customer-assets.emergentagent.com/job_respiro-retreat/artifacts/aq45bb2s_4.jpg',
    alt: 'Cape Verde beach'
  },
  {
    src: '/terrace.webp',
    alt: 'Villa terrace'
  }
];

const ImageBanner = () => {
  const lightbox = useLightbox(IMAGES.length);

  return (
    <>
      <section 
        className="py-1 md:py-4 bg-white relative"
        data-testid="image-banner-section"
        style={{ isolation: 'isolate' }}
      >
        <div className="absolute inset-0 bg-white z-0" />
        
        <div className="container mx-auto px-4 md:px-12 max-w-[1400px] relative z-10">
          <div className="grid grid-cols-2 gap-3 md:gap-6">
            {IMAGES.map((image, index) => (
              <div 
                key={image.src}
                className="relative overflow-hidden bg-white"
              >
                <div 
                  className="aspect-[2/5] md:aspect-[3/5] cursor-pointer"
                  onClick={() => lightbox.open(index)}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Lightbox
        isOpen={lightbox.isOpen}
        onClose={lightbox.close}
        image={IMAGES[lightbox.currentIndex].src}
        onPrev={lightbox.prev}
        onNext={lightbox.next}
        hasPrev={true}
        hasNext={true}
      />
    </>
  );
};

export default ImageBanner;
